export default class Logs {
	public static LeroyRequestsLog(messageTitle: string, message: any) {
		console.log(
			'%c APP -> LEROY %c%s',
			'height: 25px; box; background: #263238; color:  #adff2f; font-size: 13px; padding: 2px; border: 2px solid #006400; font-weight: bold;',
			'font-size: 12px; background: #263238; color: white; font-weight:bold; margin-left: 5px; border: 2px solid grey; padding: 2px;',
			messageTitle,
			message
		);
	}

	public static LeroyResponseLog(messageTitle: string, message: any) {
		console.log(
			'%c APP <- LEROY %c%s',
			'height: 25px; box; background: #263238; color:  #adff2f; font-size: 13px; padding: 2px; border: 2px solid #006400; font-weight: bold;',
			'font-size: 12px; background: #263238; color: white; font-weight:bold; margin-left: 5px; border: 2px solid grey; padding: 2px;',
			messageTitle,
			message
		);
	}

	public static LeroyTimeout(messageTitle: string, message: any) {
		console.log(
			'%cLEROY TIMEOUT%c%s',
			'height: 25px; box; background: #263238; color:  #e1fa05; font-size: 13px; padding: 2px; border: 2px solid #e1fa05; font-weight: bold;',
			'font-size: 12px; background: #263238; color: white; font-weight:bold; margin-left: 5px; border: 2px solid grey; padding: 2px;',
			messageTitle,
			message
		);
	}

	public static LeroyError(messageTitle: string, message: any) {
		console.log(
			'%cLEROY ERROR%c%s',
			'height: 25px; box; background: #263238; color:  #f51823; font-size: 13px; padding: 2px; border: 2px solid #db072e; font-weight: bold;',
			'font-size: 12px; background: #263238; color: white; font-weight:bold; margin-left: 5px; border: 2px solid grey; padding: 2px;',
			messageTitle,
			message
		);
	}
}
